export default "__VITE_ASSET__D3oQyh4y__"